import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-s hover:text-brand-primary flex size-[40px] cursor-pointer items-center justify-center rounded-full bg-transparent transition-colors duration-150 max-md:text-xs md:size-[50px]'
  },
  variants: {
    selected: {
      true: 'heading-s-bold pointer-events-none cursor-default border-1 max-md:text-xs'
    },
    disabled: {
      true: 'text-text-inactive pointer-events-none cursor-default'
    },
    theme: {
      default: {
        base: 'text-text-main'
      },
      predator: {
        base: 'text-white'
      }
    }
  },
  compoundVariants: [
    {
      selected: true,
      theme: 'default',
      class: 'border-bg-main-inversion'
    },
    {
      selected: true,
      theme: 'predator',
      class: 'border-white'
    }
  ],
  defaultVariants: {
    theme: 'default'
  }
});
